import React from 'react';

const MapEmbedPlaceId = ({ placeId }) => {
  const iframeSrc = `https://www.google.com/maps/embed?placeid=${placeId}`;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={iframeSrc}
      ></iframe>
    </div>
  );
};

export default MapEmbedPlaceId;
